import { EDGE } from "../lib/edge";

/**
 * Standard NMLS legal footer required on all mortgage pages.
 * Houses Equal Housing Opportunity, NMLS IDs, ABA disclosure, and disclaimers.
 */
export default function MortgageDisclosure({ compact = false }) {
  return (
    <div
      className={`bg-stone-100/70 border-t border-gray-200 ${compact ? "py-8" : "py-12"}`}
      data-testid="mortgage-disclosure"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          <div className="lg:col-span-2 flex items-center gap-3">
            {/* Equal Housing Opportunity icon */}
            <svg viewBox="0 0 64 64" className="w-12 h-12" aria-label="Equal Housing Opportunity">
              <rect x="2" y="2" width="60" height="60" rx="4" fill="none" stroke="#1A1A1A" strokeWidth="2" />
              <path d="M32 12 L52 30 L46 30 L46 50 L36 50 L36 38 L28 38 L28 50 L18 50 L18 30 L12 30 Z" fill="#1A1A1A"/>
              <text x="32" y="60" textAnchor="middle" fontSize="6" fill="#1A1A1A" fontFamily="sans-serif">EQUAL HOUSING</text>
            </svg>
            <div className="text-[10px] uppercase tracking-[0.18em] text-gray-600 leading-tight">
              Equal Housing<br />Opportunity Lender
            </div>
          </div>
          <div className="lg:col-span-10 text-xs text-gray-600 leading-relaxed space-y-3">
            <p>
              <strong className="text-[#1A1A1A]">{EDGE.legal}</strong> · Company NMLS #{EDGE.nmls} ·
              {" "}{EDGE.address.street}, {EDGE.address.city} ·
              {" "}{EDGE.phone} · Toll-Free {EDGE.tollFree}.
              Loan officer: {EDGE.officer.name}, NMLS #{EDGE.officer.nmls}.
              Verify licensing at the {" "}
              <a href="https://www.nmlsconsumeraccess.org/" target="_blank" rel="noopener noreferrer" className="text-[#E63946] underline">
                NMLS Consumer Access
              </a> portal.
            </p>
            <p>
              <strong className="text-[#1A1A1A]">Affiliated Business Arrangement Disclosure:</strong>{" "}
              {EDGE.officer.name} is a licensed Texas Realtor (#{EDGE.officer.realtorNumber}) with Gens Realty, LLC
              and a licensed Loan Originator (NMLS #{EDGE.officer.nmls}) with {EDGE.legal}. Gens Realty, LLC and
              {" "}{EDGE.legal} are <strong>separate companies</strong>. You are <strong>not required</strong> to use
              {" "}{EDGE.legal} as a condition for the purchase, sale, or refinance of property. There are
              other providers of these settlement services, and you are free to shop around to determine that
              you are receiving the best services and the best rate for these services.
            </p>
            {!compact && (
              <p className="text-[11px] text-gray-500">
                Not a commitment to lend. All loans subject to credit approval, property appraisal, and underwriting
                guidelines. Rates, terms, and programs subject to change without notice. APR may vary.
                {" "}{EDGE.legal} is licensed in multiple states. Equal Housing Opportunity.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
